var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ 'max-width': _vm.maxWidth + 'px'})},[_c('div',{staticClass:"info-message",class:{'info-message-type-info':_vm.messageType === 'info',
                  'info-message-type-danger':_vm.messageType === 'danger',
                  'info-message-type-success':_vm.messageType === 'success',
                  'info-message-type-warning':_vm.messageType === 'warning'}},[_c('b',[_vm._v("!")]),_c('p',[_vm._v(_vm._s(_vm.messageText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }